import React, { useEffect } from 'react';

import { Typography } from 'antd';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import {
    FiltersContainer,
    FilterItem,
    ObjectCounter,
    FilterItemWrapper,
} from '@components/Filters/FilterForm/FilterFormUI';
import NwDivider from '@components/Gui/NwDivider';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContactsFiltersSections = () => {
    const { global } = useContactsSelector();
    const { filtersSections } = global;
    const cs_dispatch = useContactsSelectorDispatch();

    const handleOpenFiltersSection = (areaID) => {
        cs_dispatch({ type: 'OpenFiltersSection', sectionID: areaID });
    };

    return (
        <>
            <NwDivider>available filters</NwDivider>
            <FiltersContainer>
                {filtersSections && filtersSections.length > 0 ? (
                    filtersSections.map((section, index) => (
                        <FilterItem key={section.areaID} onClick={() => handleOpenFiltersSection(section.areaID)}>
                            <FilterItemWrapper count={section.counter > 0}>
                                <Typography>{section.areaName}</Typography>
                                {section.counter > 0 && <ObjectCounter>{section.counter}</ObjectCounter>}
                            </FilterItemWrapper>
                            <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} />
                        </FilterItem>
                    ))
                ) : (
                    <div>loading filters</div>
                )}
            </FiltersContainer>
        </>
    );
};
export default ContactsFiltersSections;
